import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// ─── PASTE YOUR FIREBASE CONFIG HERE ──────────────────────────────────────────
// Get this from: Firebase Console → Project Settings → Your apps → SDK setup
const firebaseConfig = {
  apiKey: "AIzaSyDxpgky65MBlC5xk1FcDHsuSJ9ZwVu3LIA",
  authDomain: "creatorkit-18506.firebaseapp.com",
  projectId: "creatorkit-18506",
  storageBucket: "creatorkit-18506.firebasestorage.app",
  messagingSenderId: "124548555833",
  appId: "1:124548555833:web:4ae43f296a25687c6859e8",
  measurementId: "G-LRE2ZEB59E"
};
// ──────────────────────────────────────────────────────────────────────────────

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);
